import constants from "../../constants";
import React from "react";
import { Trans, withTranslation } from "react-i18next";
import SubstituteSelector from "./SubstituteSelector";

const SubstituteSelectorFactory = ({
  staff,
  event,
  onAction,
  isActionExecuting,
  onCancel,
  errorMessage,
  onClearErrorMessage,
  t,
}) => {
  const text = constructText(event, t, staff.isAdmin);
  return (
    <SubstituteSelector
      staff={staff}
      event={event}
      text={text}
      onCancel={onCancel}
      onAction={onAction}
      isActionExecuting={isActionExecuting}
      errorMessage={errorMessage}
      onClearErrorMessage={onClearErrorMessage}
    />
  );
};

const constructText = (event, t, isAdmin) => {
  switch (event) {
    case constants.staffActionEvents.deactivation:
      return {
        title: t("accountOwner.deactivateStaff"),
        officeSelectionStep: {
          description: () => (
            <Trans
              i18nKey="accountOwner.officeSelectionDescription"
              values={{
                action: "deactivate",
                role: isAdmin ? "Admin " : "Staff ",
              }}
            >
              This person is an <strong>‘Account Admin’</strong> for this
              office. Do you want to deactivate this person from this office
              only or all offices?
            </Trans>
          ),
          option1: t("accountOwner.officeSelectionOption1", {
            action: "Deactivate",
            role: isAdmin ? "as an Admin " : "as a Staff ",
          }),
          option2: t("accountOwner.officeSelectionOption2", {
            action: "Deactivate",
            role: isAdmin ? "as an Admin " : "as a Staff ",
          }),
        },
      };

    case constants.staffActionEvents.removal:
      return {
        title: t("accountOwner.removeStaff"),
        officeSelectionStep: {
          description: () => (
            <Trans
              i18nKey="accountOwner.officeSelectionDescription"
              values={{
                action: "remove",
                role: isAdmin ? "Admin " : "Staff ",
              }}
            >
              This person is an <strong>‘Account Admin’</strong> for this
              office. Do you want to remove this person from this office only or
              all offices?
            </Trans>
          ),
          option1: t("accountOwner.officeSelectionOption1", {
            action: "Remove",
            role: isAdmin ? "as an Admin " : "as a Staff ",
          }),
          option2: t("accountOwner.officeSelectionOption2", {
            action: "Remove",
            role: isAdmin ? "as an Admin " : "as a Staff ",
          }),
        },
      };

    case constants.staffActionEvents.removalAsAdmin:
      return {
        title: t("accountOwner.removeAsAnAccountAdmin"),
        officeSelectionStep: {
          description: () => (
            <Trans
              i18nKey="accountOwner.officeSelectionDescription"
              values={{ action: "remove", role: "as an Admin " }}
            >
              This person is an <strong>‘Account Admin’</strong> for this
              office. Do you want to remove this person as an Admin from this
              office only or all offices?
            </Trans>
          ),
          option1: t("accountOwner.officeSelectionOption1", {
            action: "Remove",
            role: "as an Admin ",
          }),
          option2: t("accountOwner.officeSelectionOption2", {
            action: "Remove",
            role: "as an Admin ",
          }),
        },
      };

    case constants.staffActionEvents.multipleDeactivationConfirm:
      return {
        title: t("accountOwner.deactivateStaff"),
        officeSelectionStep: {
          description: (
            <Trans
              i18nKey="accountOwner.commonMultipleDesciption"
              values={{ type: t("accountOwner.deactivate").toLowerCase() }}
            >
              This person is assigned to multiple offices. Select the offices
              from which you want to deactivate this staff member.
            </Trans>
          ),
          btnText: <Trans i18nKey="accountOwner.deactivate">Deactivate</Trans>,
        },
      };
    case constants.staffActionEvents.multipleRemoveConfirm:
      return {
        title: t("accountOwner.removeStaff"),
        officeSelectionStep: {
          description: (
            <Trans
              i18nKey="accountOwner.commonMultipleDesciption"
              values={{ type: t("accountOwner.remove").toLowerCase() }}
            >
              This person is assigned to multiple offices. Select the offices
              from which you want to remove this staff member.
            </Trans>
          ),
          btnText: <Trans i18nKey="accountOwner.remove">Remove</Trans>,
        },
      };

    case constants.staffActionEvents.multipleActivationConfirm:
      return {
        title: t("accountOwner.activateStaff"),
        officeSelectionStep: {
          description: (
            <Trans
              i18nKey="accountOwner.commonMultipleDesciption"
              values={{ type: t("accountOwner.activate").toLowerCase() }}
            >
              This person is assigned to multiple offices. Select the offices
              from which you want to activate this staff member.
            </Trans>
          ),
          btnText: <Trans i18nKey="accountOwner.activate">Activate</Trans>,
        },
      };

          case constants.staffActionEvents.multipleCancelConfirm:
      return {
        title: t("accountOwner.cancelInvitationStaff"),
        officeSelectionStep: {
          description: (
            <Trans
              i18nKey="accountOwner.commonMultipleDesciption"
              values={{ type: t("accountOwner.cancelInvitation").toLowerCase() }}
            >
              This person is assigned to multiple offices. Select the offices
              from which you want to cancel invitation this staff member.
            </Trans>
          ),
          btnText: <Trans i18nKey="accountOwner.cancelInvitation">Cancel Invitation</Trans>,
        },
      };

    default:
      throw new Error(`Prop 'event' is required.`);
  }
};

export default withTranslation()(SubstituteSelectorFactory);
